import { render, staticRenderFns } from "./AdmCreation.vue?vue&type=template&id=5e0316ce"
import script from "./AdmCreation.vue?vue&type=script&lang=js"
export * from "./AdmCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports